import {
  createDefaultProposalFilters,
  createDefaultProposalFiltersNames,
} from '@/utils/workerCreditContractManagement';

export default {
  proposal: {},
  filters: createDefaultProposalFilters(),
  filtersNames: createDefaultProposalFiltersNames(),
  filterSearched: false,
};
